import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import FormDialog from "./components/formDialogue";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Icon, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from "@mui/material";
import TablePagination from '@mui/material/TablePagination';
import TableFooter from '@mui/material/TableFooter';
import { useLocation, useNavigate } from "react-router-dom";
import { useGetAllCategoryQuery, useDeleteCategoryMutation, useReorderCategoriesMutation } from "App/services/categoryServiceApi";
import EditFormDialog from "./components/EditFormDialogue";
import Loading from "components/Loading";
import { BASE_URL } from "baseConfig";
import useReorder from "components/Reorder/useReorder";
import useFeatureEnabled from "components/FeatureToggle/useFeatureEnabled";
import ReorderableTableRow, { DragColumnHeader } from "components/Reorder/ReorderableTableRow";


function Category() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const dragDropEnabled = useFeatureEnabled("drag_drop_reorder");
  const navigate = useNavigate();
  const location = useLocation()
  const data = location.state || {};

  // const {data: categories, isError, isLoading, isFetching, error } = useGetSearchCategoryQuery(data.data);

  const {
    data: categories,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
  } = useGetAllCategoryQuery({
    refetchOnFocus: false,
  });

  const [deleteCategory] = useDeleteCategoryMutation();
  const [reorderCategories] = useReorderCategoriesMutation();

  const { ordered: sortedCategories, handleDragStart, handleDragOver, handleDrop } = useReorder(
    categories,
    (ids) => reorderCategories({ orderedIds: ids }).catch((err) => console.log(err))
  );

  if (isLoading || isFetching) {
    return <Loading />;
  }

  // if (isError) {

  //   return <NotFound error={error} />;
  // }


  // Delete Botton and Delete Dialog Box work

  const handleDeleteCategory = async () => {
    try {
      await deleteCategory(deleteId);
      setDeleteDialogOpen(false);
      setDeleteId(null);
      if (categories.length === 1) {
        window.location.reload(); 
      } else {
        
        refetch();
      }
    } catch (error) {

      console.error("Failed to delete chapter:", error);
    }
  };


  const handleDeleteConfirmation = (categoryId) => {
    setDeleteId(categoryId);
    setDeleteDialogOpen(true);
  };



  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setDeleteId(null);
  };


     // Category Id navigate to SubCategory

  const handleNavigateSubCategory = async (categoryId) => {

    navigate('/subcategory', { state: { data: categoryId } });
  }


      // Pagination System
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (categories ?
// check any Category  
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info" 
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <MDTypography variant="h6" color="white">
                  Category
                </MDTypography>
               
                <FormDialog />
              </MDBox>
              <TableContainer>
                <Table>
                  <TableHead >
                    <TableRow >
                    <DragColumnHeader enabled={dragDropEnabled} />
                    <TableCell>Image</TableCell>
                    <TableCell>Name</TableCell>
                      <TableCell sx={{textAlign:'right', paddingRight:20}}>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(rowsPerPage > 0
                      ? sortedCategories && sortedCategories.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      : sortedCategories
                    ).map((category) => (
                      <ReorderableTableRow
                        key={category.id}
                        id={category.id}
                        dragEnabled={dragDropEnabled}
                        onDragStart={handleDragStart}
                        onDragOver={handleDragOver}
                        onDrop={handleDrop}
                        sx={{ '&:hover': { backgroundColor: '#f5f5f5' } }}
                      >
                        <TableCell sx={{ textAlign: 'left',  cursor:'pointer','&:hover img': {transform: 'scale(1.05)', transition: 'transform 0.3s ease-in-out'}}}><img src={`${BASE_URL}${category.imagePath}`} height={100} width={100} onClick={() => handleNavigateSubCategory(category.id)}/></TableCell>
                        <TableCell sx={{ textAlign: 'left', textDecorationLine:'underline', cursor:'pointer','&:hover': {color: 'blue'} }} onClick={() => handleNavigateSubCategory(category.id)}>{category.name}</TableCell>

                        <TableCell sx={{textAlign:'right', paddingRight:17}}>
                          <Tooltip title="Edit">
                            <span>
                              <EditFormDialog category={category} />
                            </span>
                          </Tooltip>
                          <Tooltip title="Delete">
                            <IconButton aria-label="delete" onClick={() => handleDeleteConfirmation(category.id)} >
                              <Icon>delete</Icon>
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </ReorderableTableRow>
                    ))}
                  </TableBody>

                   {/* pagination */}

                  <TableFooter>
                    <TableRow  >
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                        colSpan={dragDropEnabled ? 4 : 3}
                        count={sortedCategories.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        SelectProps={{
                          inputProps: {
                            'aria-label': 'rows per page',
                          },
                          native: true,
                        }}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        // ActionsComponent={TablePaginationActions}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {/* <Footer /> */}

       {/* Delete Dialog Box Open */}

      <Dialog
        open={deleteDialogOpen}
        onClose={handleCloseDeleteDialog}
        sx={{textAlign:'center'}}
      >
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
          Are you sure you want to delete this category and all its questions, chapters, and subcategories?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeleteCategory} style={{ color: 'red' }}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
    :

      // not Available any Category show only Head components 

    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}  
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <MDTypography variant="h6" color="white">
                  Category
                </MDTypography>
                <FormDialog />
              </MDBox>
              <TableContainer>
                <Table>
                  <TableHead >
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  </Table>
                  </TableContainer>
                  </Card>
                  </Grid>
                  </Grid>
                  </MDBox>
                  </DashboardLayout>
                  
  );
}

export default Category;
